import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LocationLegacyModule } from '@core/components/legacy-input/search-one/location/location.module';
import { UserGroupLegacyModule } from '@core/components/legacy-input/search-one/user-group/user-group.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterUsersComponent } from './filter-users.component';
@NgModule({
  declarations: [
    FilterUsersComponent
  ],
  imports: [
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatRippleModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatToolbarModule,
    LocationLegacyModule,
    UserGroupLegacyModule
  ],
  exports: [
    FilterUsersComponent
  ]
})
export class FilterUsersModule {}
